import classNames from 'classnames';
import { useId } from 'react';

import { FormToggle } from '~components/Forms/FormToggle';
import { Markdown } from '~components/Markdown';

import styles from './FormCheckbox.module.scss';
import { FormCheckboxProps } from './types';

export function FormCheckbox({
  name,
  id,
  children,
  text = 'Я принимаю условия <a target="_blank" href="https://help.mail.ru/legal/terms/potentialpartners/ru/">пользовательского соглашения</a>',
  value,
  checked,
  required,
  isError,
  onChange,
  readonly,
}: FormCheckboxProps) {
  const uID = useId();
  const inputID = id || uID;

  return (
    <div className={classNames(styles.wrapper)}>
      <FormToggle
        id={inputID}
        name={name}
        value={value}
        checked={checked}
        required={required}
        isError={isError}
        onChange={onChange}
        readonly={readonly}
      />
      <label htmlFor={inputID} className={styles.text}>
        {children || <Markdown markdownString={text} />}
      </label>
    </div>
  );
}
